module.exports = __webpack_public_path__ + "img/shipping.92fa1916.svg";